import { useState } from "react";
import classNames from "classnames";

// Components
import WelcomeBonusCardFront from "components/molecules/WelcomeBonusCardFront";
import WelcomeBonusCardBack from "components/molecules/WelcomeBonusCardBack";

import "./styles.sass";
import { BonusType } from "../../../types/info";

type WelcomeBonusCardProps = {
  expireDate: string;
  isActive: boolean;
  sumDeposit: number;
  getBonus: () => void;
  bonusData: BonusType;
};

const WelcomeBonusCard = (props: WelcomeBonusCardProps) => {
  const { expireDate, isActive, sumDeposit, bonusData, getBonus } = props;
  const [isOpen, setIsOpen] = useState(false);

  const handleInfoToggle = () => {
    setIsOpen(!isOpen);
  };

  const rotateClass = classNames("WelcomeBonusCardWrapper", {
    toggle: isOpen,
  });

  const cardClass = classNames("WelcomeBonusCardContainer", {
    hidden: !!sumDeposit,
  });

  return (
    <div className={cardClass}>
      <div className={rotateClass}>
        <WelcomeBonusCardFront
          expireDate={expireDate}
          isActive={isActive}
          getBonus={getBonus}
          onClick={handleInfoToggle}
          bonusData={bonusData}
        />
        <WelcomeBonusCardBack
          onClick={handleInfoToggle}
          bonusData={bonusData}
        />
      </div>
    </div>
  );
};

export default WelcomeBonusCard;
